export enum ZoneCreationSource {
    Hardware,
    User
}
